import { defineMessages, useIntl } from 'react-intl'
import { ClientTeamMembership } from '../../../types/clientTeamMembership'
import { TeamCard } from './TeamCard'
import { LoadingSpinner } from '@homebotapp/hb-react-component-catalog'

const MSG = defineMessages({
  realEstateAgent: {
    id: 'TeamMemberCard.realEstateAgent',
    defaultMessage: 'Real Estate Agent'
  },
  loanOfficer: {
    id: 'TeamMemberCard.loanOfficer',
    defaultMessage: 'Loan Officer'
  },
  insuranceAgent: {
    id: 'TeamMemberCard.insuranceAgent',
    defaultMessage: 'Insurance Agent'
  }
})

interface TeamMemberCardProps {
  membership: ClientTeamMembership
  clientId: string
}

export const TeamMemberCard = ({ membership, clientId }: TeamMemberCardProps) => {
  const customerProfile = membership.customerProfile
  const intl = useIntl()
  const isLoading = !membership
  const customerFullName = `${customerProfile.firstName} ${customerProfile.lastName}`
  const scheduleACallUri = membership.customerProfile.appointmentLinkUri
  if (isLoading) {
    return <LoadingSpinner />
  }

  const getTitle = () => {
    if (membership.customerProfile.type === 'RealEstateAgent') {
      return intl.formatMessage(MSG.realEstateAgent)
    } else if (membership.customerProfile.type === 'LoanOfficer') {
      return intl.formatMessage(MSG.loanOfficer)
    } else if (membership.customerProfile.type === 'InsuranceAgent') {
      return intl.formatMessage(MSG.insuranceAgent)
    } else {
      return intl.formatMessage(MSG.realEstateAgent)
    }
  }

  return (
    <TeamCard
      clientTeamMembership={membership}
      teamMemberName={customerFullName}
      email={customerProfile.email}
      photoUri={customerProfile.photoUri}
      corporatePhotoUri={membership.corporateProfile.avatarUri}
      phone={customerProfile.phone}
      license={customerProfile.stateLicense}
      isVerified={membership.isVerified}
      clientId={clientId}
      title={getTitle()}
      corporateProfileName={membership.corporateProfile.name}
      scheduleACallUri={scheduleACallUri}
    ></TeamCard>
  )
}
